import { Heading } from '../components_catalyst/heading';
import { Text } from '../components_catalyst/text';
import { Button } from '../components_catalyst/button';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { openUserbackWidget } from '../components_feedback';

export function FeedbackPage() {
  useDocumentTitle('Feedback', { addSuffix: true });

  return (
    <main className="max-w-4xl mx-auto space-y-6 p-4">
      <Heading level={1}>Feedback</Heading>

      <div className="space-y-4">
        <Text>
          We're constantly working to improve MilestoneMap.org. Your feedback helps us understand
          what's working well and what needs improvement.
        </Text>

        <Text>
          Use the feedback button to share your thoughts — whether it's a bug report, feature
          request, or general suggestion, we appreciate your input! You can also capture screenshots
          to help us understand the issue better.
        </Text>

        <Button onClick={() => openUserbackWidget()} color="blue">
          Open Feedback Form
        </Button>
      </div>
    </main>
  );
}
